import { Pipe, PipeTransform } from '@angular/core';
import { Breakpoint } from '../../../../services/media-query.service';
import { ReportTypeKey } from '../types/report-type-key';
import { GroupType } from '../types/group-type';
import { GridHeader } from '../models/gridHeader';

@Pipe({
  name: 'rankingsHeadersSort'
})
export class RankingsHeadersSortPipe implements PipeTransform {
  transform(
    gridHeaders: Array<GridHeader>,
    configKey: ReportTypeKey,
    selectedGroup: GroupType,
    breakPoint: Breakpoint
  ): Array<GridHeader> {
    if (
      breakPoint > Breakpoint.sm &&
      configKey === 'publisher-trust-index' &&
      gridHeaders?.length > 0
    ) {
      const withoutCoppa = gridHeaders.filter(
        header => header.key !== 'coppaAudience'
      );
      const coppaHeader = gridHeaders.find(
        header => header.key === 'coppaAudience'
      );
      return [
        ...withoutCoppa.slice(0, 3),
        coppaHeader,
        ...withoutCoppa.slice(3)
      ];
    }

    return gridHeaders;
  }
}
